import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ASSET_STATUS_OPTIONS, NOT_AFFECTED_STATUS_OPTION } from '../../../../../status-badge/status.const';

@Component({
  selector: 'mtm-variant-status-dropdown',
  templateUrl: './variant-status-dropdown.component.html',
  styleUrl: './variant-status-dropdown.component.scss',
  standalone: false,
})
export class VariantStatusDropdownComponent {
  @Input() content!: any;
  @Input() variant!: any;
  @Input() variantStatus!: string;
  @Input() showStatus!: boolean;
  @Input() projectStatus!: any;
  @Input() projectColor!: { [key: string]: string };

  @Output() statusChange = new EventEmitter<{ content: any; variantId: string; status: string }>();

  readonly assetStatusOptions = ASSET_STATUS_OPTIONS;
  readonly notAffectedOption = NOT_AFFECTED_STATUS_OPTION;

  getSafeVariantStatus(): string {
    return this.variantStatus || 'NOT_AFFECTED';
  }

  shouldShowStatus(): boolean {
    return this.showStatus && !!this.variantStatus;
  }

  isDropdownDisabled(): boolean {
    return !this.getSafeVariantStatus() || this.getSafeVariantStatus() === 'NOT_AFFECTED';
  }

  onChangeStatus(status: string): void {
    this.statusChange.emit({
      content: this.content,
      variantId: this.variant.id,
      status: status,
    });
  }

  stopPropagation(event: Event): void {
    event.stopImmediatePropagation();
  }
}
